// AddJumpPage.jsx
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Background from "./asserts/pic.png";
import { authFetch } from "./auth";

// const jumpTypes = ["Fun", "Freefly", "Точность", "Групповая акробатика", "Wingsuit"];
const aircraftTypes = ["Ан-28", "Cessna", "Ан-2", "Skyvan", "Pilatus"];

const AddJumpPage = () => {
  const [formData, setFormData] = useState({
    dropzoneName: "",
    country: "",
    city: "",
    jumpType: "",
    comment: "",
    canopyType: "",
    aircraftType: "",
    datetime: "",
    files: [],
  });
  const [isDropzoneSelected, setIsDropzoneSelected] = useState(false);
  const [isJumpTypeSelected, setIsJumpTypeSelected] = useState(false);
  const [dropzones, setDropzones] = useState([]);
  const [filteredDropzones, setFilteredDropzones] = useState([]);
  const [filteredJumpType, setFilteredJumpType] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showJumpTypeDropdown, setShowJumpTypeDropdown] = useState(false);
  const jumpTypes = ["Belly", "RW", "CRW", "FreeFly", "Wingsuit", "Swoop", "Angle", "XRW", "Hop-n-Pop", "Студенческий", "Инструкторский", "Base", "SpeedFly", "Ознакомительный", "Тандем-пассажир", "Тандем-мастер", "Оператор"];
  const [jumpTypeInput, setJumpTypeInput] = useState("");
  const filteredJumpTypes = jumpTypes.filter(type =>
    type.toLowerCase().includes(jumpTypeInput.toLowerCase())
  );


  const [tooltip, setTooltip] = useState({
    visible: false,
    x: 0,
    y: 0
  });
  const [inputMode, setInputMode] = useState("altimeter"); // altimeter | manual
  const [jumpCount, setJumpCount] = useState(1);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, files: Array.from(e.target.files) }));
  };
  const selectDropzone = (dz) => {
    setFormData((prev) => ({
      ...prev,
      dropzoneName: dz.name,
      city: dz.city,
      country: dz.country,
    }));

    setIsDropzoneSelected(true); // ✅ выбрали
    setShowDropdown(false);
  };
  useEffect(() => {
    const fetchDropzones = async () => {
      try {
        const res = await authFetch("/api/dropzones");
        const data = await res.json();
        setDropzones(data);
      } catch (e) {
        console.error(e);
      }
    };

    fetchDropzones();
  }, []);

  const handleDropzoneSearch = (value) => {
    handleChange({ target: { name: "dropzoneName", value } });

    if (!value) {
      setFilteredDropzones([]);
      return;
    }

    const filtered = dropzones.filter((dz) =>
      dz.name.toLowerCase().includes(value.toLowerCase()) ||
      dz.city.toLowerCase().includes(value.toLowerCase()) ||
      dz.country.toLowerCase().includes(value.toLowerCase()) 
    );

    setFilteredDropzones(filtered);
    setShowDropdown(true);
  };




  const dropdownRef = useRef(null);
  const jumpTypeRef = useRef(null);
  const displayedDropzones =
    formData.dropzoneName?.trim() === ""
      ? dropzones
      : filteredDropzones;
  const renderJumpTypeInput = () => (
    <div style={{ ...fieldStyle, position: "relative" }}>
      <label style={labelStyle}>
        🪂 Тип прыжка
      </label>

      <input
        type="text"
        value={jumpTypeInput}
        placeholder="Фан, Фрифлай..."
        onChange={(e) => {
          const value = e.target.value;
          setJumpTypeInput(value);
          setFormData(prev => ({ ...prev, jumpType: value }));
        }}
        onFocus={() => {
          handleDropzoneSearch(formData.dropzoneName || "");
        }}
        style={inputStyle}
      />

      {/* ВЫПАДАЮЩИЙ СПИСОК */}
      {filteredJumpTypes.length > 0 && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            background: "#1F2937",
            borderRadius: "8px",
            marginTop: "4px",
            maxHeight: "150px",
            overflowY: "auto",
            zIndex: 1000,
            boxShadow: "0 8px 20px rgba(0,0,0,0.4)"
          }}
        >
          {filteredJumpTypes.map((type, index) => (
            <div
              key={index}
              onClick={() => {
                setJumpTypeInput(type);
                setFormData(prev => ({ ...prev, jumpType: type }));
              }}
              style={{
                padding: "8px 10px",
                cursor: "pointer",
                color: "#fff"
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = "#374151"}
              onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
            >
              {type}
            </div>
          ))}
        </div>
      )}
    </div>
  );
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
      if (jumpTypeRef.current && !jumpTypeRef.current.contains(event.target)) {
        setShowJumpTypeDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //       setShowDropdown(false);
  //     }
  //     if (jumpTypeRef.current && !jumpTypeRef.current.contains(event.target)) {
  //     }
  //   };

  //   document.addEventListener("click", handleClickOutside); // 👈 ВАЖНО
  //   return () => document.removeEventListener("click", handleClickOutside);
  // }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isDropzoneSelected) {
      alert("Выберите дропзону из списка");
      return;
    }

    if (!isJumpTypeSelected) {
      alert("Выберите тип прыжка из списка");
      return;
    }
    if (jumpCount > 1) {
      const confirmSave = window.confirm(
        `Вы собираетесь добавить ${jumpCount} прыжков.\nВсе введённые данные будут применены ко всем прыжкам.\nПродолжить?`
      );
      if (!confirmSave) return;
    }
    const data = new FormData();

    // Добавляем метаданные
    data.append("dropzoneName", formData.dropzoneName);
    data.append("country", formData.country);
    data.append("city", formData.city);
    data.append("jumpType", formData.jumpType);
    data.append("comment", formData.comment);
    data.append("canopyType", formData.canopyType);
    data.append("aircraftType", formData.aircraftType);

    // Object.keys(formData).forEach(key => {
    if (inputMode === "altimeter") {
      // Добавляем все файлы с одним ключом "files"
      formData.files.forEach((file) => {
        data.append("files", file);
      });
    } else {
      data.append("exitHeight", formData.exitHeight);
      data.append("deployHeight", formData.deployHeight);
      data.append("freefallTime", formData.freefallTime);
      if (formData.datetime) {
        data.append("datetime", formData.datetime + ":00");
      }
    }
    // });

    data.append("inputMode", inputMode);
    data.append("jumpCount", jumpCount);

    try {
      const res = await authFetch("/api/jumpdata/upload", {
        method: "POST",
        body: data,
      });

      if (res.ok) {
        navigate("/jumps");
      } else {
        alert("Ошибка при загрузке");
      }
    } catch (err) {
      console.error(err);
      alert("Произошла ошибка при загрузке");
    }
  };

  const renderInput = ({ label, name, placeholder = "", icon = "✏️", type = "text" }) => (
    <div style={fieldStyle}>
      <label style={labelStyle}>
        {icon} {label}
      </label>
      <input
        type={type}
        name={name}
        placeholder={placeholder}
        value={formData[name]}
        onChange={handleChange}
        style={inputStyle}
      />
    </div>
  );
  const renderDisabledInput = ({ label, name, placeholder = "", icon = "✏️", type = "text" }) => (
    <div style={fieldStyle}>
      <label style={{ ...labelStyle, opacity: 0.5 }}>
        {icon} {label}
      </label>
      <input
        type={type}
        name={name}
        placeholder={placeholder}
        value={formData[name]}
        disabled
        onChange={handleChange}
        style={inputStyle}
      />
    </div>
  );

  const renderDatalistInput = ({ label, name, options, placeholder = "" }) => (
    <div style={fieldStyle}>
      <label style={labelStyle}>{label}</label>
      <input
        list={`${name}-list`}
        name={name}
        placeholder={placeholder}
        value={formData[name]}
        onChange={handleChange}
        style={inputStyle}
      />
      <datalist id={`${name}-list`}>{options.map((opt) => <option key={opt} value={opt} />)}</datalist>
    </div>
  );

  return (
    <>
      {/* Фиксированный фон */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundImage: `url(${Background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          zIndex: -1,
        }}
      />

      {/* Контент */}
      <div
        style={{
          minHeight: "100vh",
          padding: isMobile ? "20px 12px" : "40px 20px",
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
          color: "#fff",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          boxSizing: "border-box",
        }}
      >
        {/* ТВОЯ ФОРМА */}
        <form onSubmit={handleSubmit} style={formStyle}>
          <h2 style={{ textAlign: "center", marginBottom: "30px", fontSize: "26px" }}>
            🪂 Добавить новые прыжки
          </h2>

          <fieldset style={sectionStyle}>
            <legend style={legendStyle}>📍 Дропзона</legend>
            <div style={{ ...gridStyle, gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)" }}>
              {/* {renderInput({ label: "Название", name: "dropzoneName", icon: "🏁", placeholder: "DZ Dubki, Ватулино..." })} */}
              <div style={fieldStyle}>
                <label style={labelStyle}>🏁 Название</label>

                <div
                  style={{ position: "relative" }}
                  ref={dropdownRef}
                  onClick={(e) => e.stopPropagation()}   // 👈 ВАЖНО
                >
                  <input
                    type="text"
                    value={formData.dropzoneName}
                    onChange={(e) => {
                      handleDropzoneSearch(e.target.value)
                      setIsDropzoneSelected(false);
                    }}
                    onFocus={() => { setShowDropdown(true) }}
                    style={inputStyle}
                    placeholder="Начни вводить..."
                  />

                  {/* DROPDOWN */}
                  {showDropdown && displayedDropzones.length > 0 && (
                    <div
                      style={{
                        maxHeight: isMobile ? "180px" : "220px",
                        fontSize: isMobile ? "14px" : "15px",
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        background: "#111827",
                        borderRadius: "8px",
                        // maxHeight: "200px",
                        overflowY: "auto",
                        zIndex: 1000,
                        marginTop: "4px",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.5)"
                      }}
                    >
                      {displayedDropzones.map((dz, i) => (
                        <div
                          key={i}
                          onClick={(e) => {
                            // e.stopPropagation();
                            selectDropzone(dz)
                          }
                          }
                          style={{
                            padding: "10px",
                            cursor: "pointer",
                            borderBottom: "1px solid #1F2937"
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.background = "#1F2937"}
                          onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}

                        >
                          {dz.name} ({dz.city}, {dz.country})
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              {renderDisabledInput({ label: "Страна", name: "country", icon: "🌍", placeholder: " - " })}
              {renderDisabledInput({ label: "Город", name: "city", icon: "🏙️", placeholder: " - " })}
            </div>
          </fieldset>

          <fieldset style={sectionStyle}>
            <legend style={legendStyle}>📝 Подробности прыжка</legend>
            <div style={gridStyle}>
              {/* {renderJumpTypeInput()} */}
              <div style={fieldStyle}>
                <label style={{ ...fieldStyle, labelStyle }}>🪂 Тип прыжка</label>

                <div
                  style={{ position: "relative" }}
                  ref={jumpTypeRef}
                  onClick={(e) => e.stopPropagation()}   // 👈 ВАЖНО
                >
                  <input
                    type="text"
                    value={jumpTypeInput}
                    placeholder="FreeFly, Belly..."
                    onFocus={() => {
                      setShowJumpTypeDropdown(true);
                      setShowDropdown(false);
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      setJumpTypeInput(value);
                      setIsJumpTypeSelected(false);
                      setFormData(prev => ({ ...prev, jumpType: value }));
                    }}
                    style={inputStyle}
                  />

                  {/* ВЫПАДАЮЩИЙ СПИСОК */}
                  {showJumpTypeDropdown && filteredJumpTypes.length > 0 && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        background: "#1F2937",
                        borderRadius: "8px",
                        marginTop: "4px",
                        maxHeight: "150px",
                        overflowY: "auto",
                        zIndex: 1000,
                        boxShadow: "0 8px 20px rgba(0,0,0,0.4)"
                      }}
                    >
                      {filteredJumpTypes.map((type, index) => (
                        <div
                          key={index}
                          onClick={() => {
                            setJumpTypeInput(type);
                            setFormData(prev => ({ ...prev, jumpType: type }));
                            setIsJumpTypeSelected(true);
                            setShowJumpTypeDropdown(false);
                          }}
                          style={{
                            padding: "8px 10px",
                            cursor: "pointer",
                            color: "#fff"
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.background = "#374151"}
                          onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                        >
                          {type}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {renderInput({ label: "Комментарий", name: "comment", icon: "💬", placeholder: "заметки по прыжку" })}
            </div>
          </fieldset>

          <fieldset style={sectionStyle}>
            <legend style={legendStyle}>🎒 Оборудование</legend>
            <div style={gridStyle}>
              {renderInput({ label: "Тип парашюта", name: "canopyType", icon: "🪂", placeholder: "Commodore, Ultimate..." })}
              {renderDatalistInput({
                label: "Тип летательного аппарата",
                name: "aircraftType",
                options: aircraftTypes,
                placeholder: "АН-28, Pilatus, Другое...",
              })}
            </div>
          </fieldset>

          {/* === РЕЖИМ ВВОДА === */}
          <fieldset style={sectionStyle}>
            <legend style={legendStyle}>📊 Способ добавления</legend>

            <div style={{
              display: "flex",
              gap: "15px",
              flexDirection: isMobile ? "column" : "row"
            }}>
              <button
                type="button"
                onClick={() => setInputMode("altimeter")}
                style={{
                  ...modeButtonStyle,
                  backgroundColor: inputMode === "altimeter" ? "#10B981" : "#333"
                }}
              >
                📄 Загрузка логов
              </button>

              <button
                type="button"
                onClick={() => setInputMode("manual")}
                style={{
                  ...modeButtonStyle,
                  backgroundColor: inputMode === "manual" ? "#10B981" : "#333"
                }}
              >
                ✏️ Ручной ввод
              </button>
            </div>
          </fieldset>

          {/* === РУЧНОЙ ВВОД === */}
          {inputMode === "manual" && (
            <><fieldset style={sectionStyle}>
              <legend style={legendStyle}>🔢 Количество прыжков</legend>

              <div style={gridStyle}>
                <div style={fieldStyle}>
                  <label style={labelStyle}>Сколько прыжков добавить?</label>
                  <input
                    type="number"
                    min="1"
                    value={jumpCount}
                    onChange={(e) => setJumpCount(Number(e.target.value))}
                    style={inputStyle} />
                </div>
              </div>
            </fieldset>

              {/* 👇 НОВЫЙ БЛОК ДАТЫ */}
              <fieldset style={sectionStyle}>
                <legend style={legendStyle}>📅 Дата и время прыжка</legend>

                <div style={gridStyle}>
                  <div style={fieldStyle}>
                    <label style={labelStyle}>Дата и время</label>
                    <input
                      type="datetime-local"
                      name="datetime"
                      min="2000-01-01T00:00"
                      max="2099-12-31T23:59"
                      value={formData.datetime}
                      onChange={handleChange}
                      style={{
                        ...inputStyle,
                        padding: "9px",
                      }}
                    />
                  </div>
                </div>
              </fieldset>

              <fieldset style={sectionStyle}>
                <legend style={legendStyle}>📐 Параметры прыжка</legend>

                <div style={gridStyle}>
                  {renderInput({
                    label: "Высота отделения (м)",
                    name: "exitHeight",
                    type: "number",
                    placeholder: "4000"
                  })}

                  {renderInput({
                    label: "Высота раскрытия (м)",
                    name: "deployHeight",
                    type: "number",
                    placeholder: "1000"
                  })}

                  {renderInput({
                    label: "Время свободного падения",
                    name: "freefallTime",
                    type: "number",
                    placeholder: "55"
                  })}
                </div>
              </fieldset></>
          )}

          {/* === ЗАГРУЗКА ФАЙЛОВ === */}
          {inputMode === "altimeter" && (
            <fieldset style={sectionStyle}>
              <legend style={legendStyle}>📄 Лог-данные с высотомера</legend>
              <div style={gridStyle}>
                <div style={fieldStyle}>
                  <label style={labelStyle}>Выберите один или несколько лог-файлов</label>
                  <input
                    type="file"
                    multiple
                    accept=".txt,.log"
                    onChange={handleFileChange}
                    style={{ ...inputStyle, padding: "7px", backgroundColor: "#111", color: "#fff" }}
                  />
                  <div style={{ marginTop: "6px" }}>
                    <p style={{ fontStyle: "italic", fontSize: "13px", color: "#ccc", marginBottom: "6px" }}>
                      Если выбрать несколько файлов, к каждому прыжку будет сохранена введённая выше информация.
                    </p>

                    <span
                      style={{
                        fontStyle: "italic",
                        fontSize: "13px",
                        textDecoration: "underline",
                        cursor: "pointer",
                        color: "#10B981"
                      }}
                      onMouseEnter={(e) => {
                        setTooltip({
                          visible: true,
                          x: e.clientX,
                          y: e.clientY
                        });
                      }}
                      onMouseMove={(e) => {
                        setTooltip(prev => ({
                          ...prev,
                          x: e.clientX,
                          y: e.clientY
                        }));
                      }}
                      onMouseLeave={() =>
                        setTooltip(prev => ({ ...prev, visible: false }))
                      }
                    >
                      Список поддерживаемых высотомеров
                    </span>
                  </div>
                </div>
              </div>
            </fieldset>

          )}

          <button type="submit" style={buttonStyle}>📤 Сохранить</button>
          <button type="button" onClick={() => navigate("/")} style={buttonStyle}>⬅️ На главную</button>
        </form>

        {tooltip.visible && (
          <div
            style={{
              position: "fixed",
              top: tooltip.y + 15,
              left: tooltip.x + 15,
              backgroundColor: "rgba(17, 24, 39, 0.98)",
              padding: "12px 15px",
              borderRadius: "10px",
              boxShadow: "0 6px 18px rgba(0,0,0,0.4)",
              fontSize: "13px",
              width: "260px",
              zIndex: 9999,
              color: "#F3F4F6",
              pointerEvents: "none",
              transition: "opacity 0.15s ease"
            }}
          >
            <div>• ProTrack 2</div>

            <div
              style={{
                marginTop: "8px",
                fontSize: "12px",
                opacity: 0.7,
                borderTop: "1px solid rgba(255,255,255,0.2)",
                paddingTop: "6px"
              }}
            >
              Для дополнения списка — обратитесь к администрации
            </div>
          </div>
        )}

      </div>
    </>
  );
};

// === Стили ===
const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
  gap: "20px",
};

const sectionStyle = {
  border: "1px solid #444",
  borderRadius: "10px",
  padding: "20px",
  marginBottom: "25px",
};

const legendStyle = {
  fontWeight: "bold",
  padding: "0 10px",
  fontSize: "18px",
};

const labelStyle = {
  display: "block",
  marginBottom: "6px",
  fontWeight: "bold",
};

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  borderRadius: "10px",
  border: "1.8px solid #444",
  outline: "none",
  backgroundColor: "#1a1a1a",
  color: "#eee",
  fontSize: "15px",
  fontWeight: "500",
  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  transition: "border-color 0.25s ease, box-shadow 0.25s ease",
  boxShadow: "inset 0 0 6px #000000cc",
  caretColor: "#FFD700",
  boxSizing: "border-box",
};

const fieldStyle = {
  display: "flex",
  flexDirection: "column",
  backgroundColor: "#222",
  padding: "10px 14px",
  borderRadius: "12px",
  boxShadow: "0 1px 6px rgba(0,0,0,0.7)",
};

const formStyle = {
  backgroundColor: "rgba(0, 0, 0, 0.9)",
  borderRadius: "16px",
  padding: "40px 30px",
  maxWidth: "1000px",
  width: "100%",
  boxShadow: "0 8px 30px rgba(0,0,0,0.85)",
  boxSizing: "border-box",
};

const buttonStyle = {
  width: "100%",
  backgroundColor: "#FFD700",
  color: "#000",
  padding: "14px",
  fontSize: "16px",
  fontWeight: "bold",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  transition: "background 0.3s",
  marginBottom: "15px",
};

const modeButtonStyle = {
  flex: 1,
  padding: "12px",
  borderRadius: "10px",
  border: "none",
  color: "#fff",
  cursor: "pointer",
  fontWeight: "bold"
};

export default AddJumpPage;
